import NextButton from "legacy/boater-reservation-flow/NextButton"
import StripeElement from "legacy/credit-cards/StripeElement"
import PropTypes from "prop-types"
import React from "react"

class AddPaymentMethod extends React.Component {
  constructor(args) {
    super(args)
    this.stripeElement = null
    this.setStripeElementRef = (element) => {
      this.stripeElement = element
    }
    this.state = {}
    this.nextButton = this.nextButton.bind(this)
    this.success = this.success.bind(this)
    this.error = this.error.bind(this)
    this.capitalize = this.capitalize.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("Add Payment Method")
  }

  nextButton() {
    this.setState({ saving: true })
    this.stripeElement.createStripePaymentMethod()
  }

  capitalize(str) {
    const lower = str.toLowerCase()
    return str.charAt(0).toUpperCase() + lower.slice(1)
  }

  success(response) {
    this.props.setGlobalState({
      paymentMethodCreated: "now",
      selectedPaymentMethod: {
        id: response.id,
        stripePaymentMethodId: response.id,
        title: `${this.capitalize(response.card.brand)} ****${
          response.card.last4
        }`,
        subtitle: `expires ${response.card.exp_month}/${response.card.exp_year}`,
        isExpired: false,
        isEditable: false,
      },
    })
    this.props.setGlobalState({ paymentMethodCreated: "now" })
    this.props.routeTo("next")
  }

  error() {
    this.setState({ saving: false })
  }

  render() {
    return (
      <div id="addPaymentMethod" className="add-payment-method">
        <StripeElement
          ref={this.setStripeElementRef}
          successCallback={this.success}
          errorCallback={this.error}
        />
        <div className="text-muted text-center">
          Your payment method is NOT charged unless the reservation is confirmed
          by the marina.
        </div>
        <NextButton
          id="addPaymentMethodContinueButton"
          btnClass="btn-primary"
          processing={this.state.saving}
          click={this.nextButton}
          icon="icon-lock-fa"
          text="Add Payment Method"
          processingText="Adding Payment Method..."
        />
      </div>
    )
  }
}

AddPaymentMethod.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
}

export default AddPaymentMethod
